import React from "react";

const SearchIcon = (flag) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="22"
        cy="22"
        r="22"
        fill={flag?.flag ? "#00aef4" : "lightgray"}
      />
      <path
        d="M32.4846 20.9064C33.4407 21.322 33.4407 22.678 32.4846 23.0936L16.3705 30.0998C14.8552 30.7586 13.3332 29.1865 14.0407 27.6933L15.8516 23.8717C16.0251 23.5057 16.3724 23.2527 16.7741 23.2L23.7101 22.2894C24.0549 22.2441 24.0563 21.7456 23.7117 21.6984L16.7675 20.7476C16.3695 20.6931 16.0257 20.4419 15.8528 20.0794L14.059 16.3178C13.3469 14.8244 14.8696 13.2477 16.3869 13.9074L32.4846 20.9064Z"
        fill="white"
      />
    </svg>
  );
};

export default SearchIcon;
